import { render } from "./vue-trix.vue?vue&type=template&id=7256f448&scoped=true"
import script from "./vue-trix.vue?vue&type=script&lang=js"
export * from "./vue-trix.vue?vue&type=script&lang=js"

import "./vue-trix.vue?vue&type=style&index=0&id=7256f448&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7256f448"]])

export default __exports__